import React from "react";
import OpcionDefecto from "../../../../../Common/Components/OpcionDefecto";
import CheckDefecto from "../../../../../Common/Components/CheckDefecto";
import ExpHelper from '../../../../../Common/Helpers/ExpHelper';

const ModelosLiquidacion = ({ data, selectCheckBox, selectCombo }) => {
    const { GET_MODELO_LIQUIDACION_ADMINISTRADORA } = data;
    const arrayAux = GET_MODELO_LIQUIDACION_ADMINISTRADORA.filter(d => d.Checked);
    const acentoLetraOminuscula = ExpHelper.ConvertirCaracter("o");

    return (
        <div className="row top-separator-xs">
            <div className="col-xs-12">
                <label className="label-primary">{"Modelos de liquidaci" + acentoLetraOminuscula + "n"}</label>
                {GET_MODELO_LIQUIDACION_ADMINISTRADORA.map((item) => {
                    const referencia = `GMLA-${item.Id}`;
                    return (
                       item.Activo && 
                        <CheckDefecto
                            key={item.Id}
                            nombre={item.Descripcion}
                            check={item.Checked}
                            activo={item.Activo}
                            referencia={referencia}
                            selectCheckBox={() => selectCheckBox("GET_MODELO_LIQUIDACION_ADMINISTRADORA", item.Id)} />
                    )
                })}
             
                <OpcionDefecto
                    selecciono={arrayAux.length}
                    infoData={arrayAux}
                    referencia={"ModeloLiquidacionDefaultId"}
                    valorCombo={data.ModeloLiquidacionDefaultId}
                    valorChecked={data.ModeloLiquidacionDefaultInterfaz}
                    selectCombo={(value) => selectCombo("ModeloLiquidacionDefaultId", value)}
                    selectCheckBox={(value) => selectCheckBox("ModeloLiquidacionDefaultInterfaz", value)}
                />

                {(!data.ERROR_PRODUCT["seleccionoModeloLiquidacion"] &&arrayAux.length===0) &&
                    <label className="error">{"Debe seleccionar al menos un modelo de liquidaci" + acentoLetraOminuscula + "n."}</label>}

            </div>
        </div>
    );
}

export default ModelosLiquidacion;